const getMainSelection = (array: { is_main: boolean; id?: number }[]) =>
  array?.find(element => element.is_main === true)?.id ?? null;

export default getMainSelection;
